import { createRngState, shuffle } from '../rng/rng';
import { questCards, artifactCards } from '../deck';
import { PHASES } from '../constants';
import { startRound } from '../actions/roundActions';

/**
 * Setup, p1 PREPARATIONS.
 *
 * "The 5 Artifact cards are shuffled placed face down, one under each of the
 * Temple cards." So the ORDER the artifacts enter the game is fixed here, at
 * setup, and never re-rolled - round 3 always gets the third one off this
 * shuffled pile. Storing it as a list rather than drawing lazily each round is
 * what makes that true.
 */
export const createGameState = ({ players, seed = 1 }) => {
  const rng0 = createRngState(seed);
  const [artifactOrder, rng1] = shuffle(artifactCards().map((c) => c.id), rng0);

  const state = {
    meta: {
      seq: 0,
      phase: PHASES.DECIDING,
      round: 0,
      turn: 0,
      // Set the moment a round ends and cleared when the next one starts, so
      // the table gets to read what happened before the temple resets.
      roundOver: null,
    },

    players: players.map((p, seat) => ({
      id: p.id,
      name: p.name,
      seat,
      isBot: Boolean(p.isBot),
      ...(p.isBot ? { botIndex: p.botIndex ?? seat } : {}),

      // Inside the tent: safe, and p3 says it "may not be lost". Hidden from
      // everyone else all game (Matt's call, and the physical game's own rule
      // on p3: other players may look at your tent "but not to touch or count
      // what is inside").
      tent: 0,
      // Artifacts standing beside the tent - public, and so is their value,
      // because the rulebook has you mark each one with a stone as it lands.
      artifacts: 0,
      artifactPoints: 0,

      inTemple: true,
      // Set only when a hazard ended a round with this player still inside -
      // "out of the temple" means two opposite things without it.
      caught: false,
      // p2: treasures taken this round are "placed beside the players' Tents,
      // not inside". Public, and still losable. This is the number every
      // other player is watching when they decide whether to push on.
      pocket: 0,
      choice: null,
    })),

    // The 30 Quest cards still in the game. Shrinks by one hazard whenever a
    // round ends in a hazard (p3).
    questRemaining: questCards().map((c) => c.id),

    // One per round, in the order fixed above.
    artifactOrder,
    // Artifacts shuffled into the deck and not yet claimed or lost. An
    // artifact still face down when the round ends stays here and comes back
    // next round - p2: "If an Artifact is not discovered in its disclosure
    // round, it may be found later in the game!"
    artifactsInPlay: [],
    artifactsLost: [],
    // How many have left the temple, table-wide. Decides 5 points or 10.
    artifactsTaken: 0,

    deck: [],
    // Revealed cards, in order. `left` is the treasure still lying on that
    // card, which is what a leaver divides up.
    path: [],
    hazardsSeen: {},
    artifactsOnPath: [],

    log: [],
    rngState: rng1,
  };

  return startRound(state);
};
